import { useNavigate } from 'react-router-dom';
import { LogOut } from './icons';

export default function LogoutButton() {
  const navigate = useNavigate();

  const handleLogout = () => {
    window.dispatchEvent(new Event('esf-logout'));
    localStorage.removeItem('authToken');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('userInfo');
    navigate('/login_page');
  };

  return (
    <button
      onClick={handleLogout}
      className="inline-flex items-center justify-center gap-2 bg-red-500 text-white px-4 py-2 rounded-lg hover:bg-red-600 transition"
    >
      <LogOut size={18} /> خروج از حساب
    </button>
  );
}
